export default "__VITE_ASSET__e3401dbc__"